// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: "dev",
  production: false,
  development: true,
  test: false,
  url: "https://dev-pendelportalen.stockholmstag.sj.se",
  loginRedirect: "https://dev-pendelportalen.stockholmstag.sj.se/signin-oidc",
  messagesBaseUrl: "https://dev-api.stockholmstag.sj.se/public/messagesapi",
  contactApiBaseUrl: "https://dev-api.stockholmstag.sj.se/public/contactapi",
  alcolockApiBaseUrl: "https://dev-api.stockholmstag.sj.se/public/drc/drivercompliance",
  alcolockApiVersion: "1",
  graphUrl: "https://graph.microsoft.com/v1.0",
  messagesApiVersion: "1",
  getMessagesApiSuffix: "/api/v1/messages",
  getToTMessagesApiSuffix: "/api/v1/messages/tot",
  getAppMessagesApiSuffix: "/api/v1/messages/app",
  createMessageApiSuffix: "/api/v1/messages",
  createMessageVersionApiSuffix: "/api/v1/messages",
  getMessagesByIdApiSuffix: "/api/v1/messages",
  markMessageReadApiSuffix: "/api/v1/messages",
  messagesScopes: "api://cddfa479-5a1c-4c43-91fa-aaa4bd9ffbf0/access_as_user",
  contactScopes: "api://79323930-fd18-449f-bf90-f2a47ed8d028/access_as_user",
  alcolockScopes: "c328157b-2286-4741-ad9d-21471679c3b2/.default",
  clientID: "c328157b-2286-4741-ad9d-21471679c3b2",
  tenantID: "2146c4ae-6471-40a8-b821-2774c8057963",
  loginUrl: "https://login.microsoftonline.com/",
  trainOnTimeAdminUrl: "https://dev-pendeltag.stockholmstag.sj.se/admin",
  trainOrderBaseUrl: "https://dev-api.stockholmstag.sj.se/public/trainorders",
  getTrainInformationsApiSuffix: "/api/v2/traininformations",
  trainOrderScopes: "api://0715a36b-2a61-4807-9c18-00029b369fb2/access_as_user",
  driverDeviationBaseUrl: "https://dev-api.stockholmstag.sj.se/public",
  driverDeviationApiVersion: "2",
  getDriverDeviationsApiSuffix: "/trainorders/api/v2/driverdeviations",
  resolveDeviationApiSuffix: "/trainorders/api/v2/driverdeviations",
  readWriteContactsGroups: ["9ec4358d-6488-409a-97b4-3f43a6505aba", "02dadc2b-1062-40f0-b858-9c4abab19a8c"],
  readWriteGroups: ["9ec4358d-6488-409a-97b4-3f43a6505aba"],
  trainOrderGroups: ["ca1d6f41-4b47-4d3c-81f7-b81ca112a448", "8e335f94-91cf-426b-865a-e57d2746077f", "dc3fc34d-2c33-4384-aaee-810fe5fc26bf", "65318c48-9a90-41d5-a8f9-543b0f945d6b", "9e683c0f-efc4-4a94-ba81-f3f88ace12da"],
  alcolockGroups: ["2bbb11c9-c60d-4cfd-8a28-171e64b27702", "5aab88e8-7200-4eae-84ac-4cc1e5b293e1", "Stanislav.Olsson@sj.se", "Mathias.Backius@sj.se", "PaIbrahim.Sanyang@sj.se"],
  driverDeviationGroups: ["Stanislav.Olsson@sj.se", "Roland.Colliander@sj.se", "Michael.Nordquist@sj.se",
    "Issa.Kobayashi@sj.se", "DGenaro.PeraltaPizarro@sj.se", "PaIbrahim.Sanyang@sj.se",
    "Sadat.Mohammed@sj.se", "Alhaji.Touray@sj.se", "Mohsen.Meshkin@sj.se", "Monica.Eriksson@sj.se"]
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js';  // Included with Angular CLI.
